import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Separator } from './ui/separator';
import { Clock, Truck, DollarSign } from 'lucide-react';

const Menu = () => {
  const regularMenu = {
    lumpia: [
      { name: "Doobie I", description: "Pork & Shrimp Shanghai", pack: "20-Pack", price: "$25.00" },
      { name: "Doobie II", description: "Pork Shanghai", pack: "20-Pack", price: "$25.00" },
      { name: "The Joint", description: "Chicken Shanghai", pack: "20-Pack", price: "$25.00" },
      { name: "The Blunt", description: "Beef & Vegetable", pack: "12-Pack", price: "$18.00" },
      { name: "The Spliff", description: "Shrimp Jalapeno Popper", pack: "12-Pack", price: "$18.00" },
      { name: "The Fatty", description: "Bacon Jalapeno Popper", pack: "12-Pack", price: "$18.00" },
      { name: "The Reefer", description: "Crab Rangoon", pack: "12-Pack", price: "$18.00" }
    ],
    pricing: [
      { pack: "12-Pack", price: "$18.00", note: "The Blunt/The Spliff/The Fatty/The Reefer" },
      { pack: "20-Pack", price: "$25.00", note: "" },
      { pack: "40-Pack", price: "$40.00", note: "Doobie I/Doobie II/The Joint" },
      { pack: "Fry Upcharge", price: "+$10.00", note: "2 sm sweet chili sauces/pack + 2 more when fried" }
    ]
  };

  return (
    <section id="menu" className="py-20 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Signature Menu
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Each lumpia is handcrafted with premium ingredients and our secret family recipes. 
            Choose from our creative flavor combinations that blend Filipino tradition with bold innovation.
          </p>
        </div>

        {/* Menu Items */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {regularMenu.lumpia.map((item, index) => (
            <Card key={index} className="hover:shadow-xl transition-all duration-300 border-2 border-yellow-200 hover:border-yellow-400 bg-white">
              <CardHeader className="pb-4">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <CardTitle className="text-xl font-bold text-gray-900 mb-2">
                      {item.name}
                    </CardTitle>
                    <CardDescription className="text-gray-700 text-base font-medium">
                      {item.description}
                    </CardDescription>
                  </div>
                  <Badge variant="secondary" className="bg-yellow-400 text-gray-900 font-semibold">
                    {item.pack}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex justify-between items-center">
                  <span className="text-2xl font-bold text-gray-900">{item.price}</span>
                  <button className="bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors">
                    Order
                  </button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Pricing Summary */}
        <Card className="bg-gradient-to-r from-yellow-100 to-amber-100 border-2 border-yellow-300">
          <CardHeader>
            <CardTitle className="text-2xl font-bold text-gray-900 text-center mb-4">
              Frozen Packs Pricing
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {regularMenu.pricing.map((item, index) => (
                <div key={index} className="text-center">
                  <div className="bg-white rounded-lg p-4 shadow-md border border-yellow-200">
                    <h4 className="font-bold text-gray-900 text-lg mb-2">{item.pack}</h4>
                    <p className="text-2xl font-bold text-gray-800 mb-2">{item.price}</p>
                    {item.note && (
                      <p className="text-sm text-gray-600 font-medium">{item.note}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Local Delivery Info */}
        <div className="mt-12">
          <Card className="bg-white border-2 border-indigo-200">
            <CardHeader>
              <CardTitle className="flex items-center justify-center space-x-2 text-xl font-bold text-indigo-900">
                <Truck className="h-6 w-6" />
                <span>Local Delivery</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-center space-y-3">
                <div className="flex items-center justify-center space-x-2 text-indigo-800">
                  <DollarSign className="h-5 w-5" />
                  <span className="font-semibold">Within 15 Miles - Free Delivery</span>
                </div>
                <div className="flex items-center justify-center space-x-2 text-indigo-800">
                  <DollarSign className="h-5 w-5" />
                  <span className="font-semibold">Outside 15 Miles - $1/Mile</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Menu;